import * as path from 'node:path';
import { getBridgeRoot } from '../../files/cwd/index.js';

/** Absolute path to a git repo under the bridge root from a repo-relative path (`.` = bridge root when it is a repo). */
export function resolveRepoAbsPathFromBridge(
  repoRelPath: string,
  bridgeRoot: string = getBridgeRoot(),
): string | null {
  const bridgeResolved = path.resolve(bridgeRoot);
  const rel = repoRelPath.trim() === '.' ? '' : repoRelPath.trim().replace(/\\/g, '/');
  const repoPath = rel === '' ? bridgeResolved : path.join(bridgeResolved, rel);
  const resolved = path.resolve(repoPath);
  if (!resolved.startsWith(bridgeResolved + path.sep) && resolved !== bridgeResolved) {
    return null;
  }
  return resolved;
}
